export function getLinkedTextAreaId (linkId) {
  if (!linkId) return null;
  const [, id] = splitLinkedTextAreaLink(linkId);

  return id;
}

export function getLinkedTextAreaPageId (linkId) {
  if (!linkId) return null;
  const [pageId] = splitLinkedTextAreaLink(linkId);

  return Number(pageId);
}

export function splitLinkedTextAreaLink (link) {
  if (!link) return [null, null];

  if (typeof link === 'object') {
    const { id, pageId } = link;

    return [pageId, id];
  }

  if (typeof link === 'string') {
    const [pageId, id] = link.split('-');

    return [pageId, id];
  }

  return [null, null];
}

export function buildLinkedTextId (pageId, id) {
  return `${pageId}-${id}`;
}
